import Vue from 'vue';

export class Vitana{

    /**
     *
     * @param idRastreador
     * @returns {Promise}
     */
    static byPK(idRastreador){
        return new Promise((ok, fail) => {
            Vue.http.get('vitana/by-pk/' + idRastreador)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    static sendTempos(json){
        return Vue.http.post('vitana/times', json);
    }

    static embarcarRFID(idRastreador){
        return Vue.http.post('vitana/embarcar-rfid', {
            id_rastreador: idRastreador
        });
    }

    static removerRFID(idRastreador){
        return Vue.http.post('vitana/remover-rfid', {
            id_rastreador: idRastreador
        });
    }

    static limparRFID(idRastreador){
        return Vue.http.post('vitana/limpar-rfid', {
            id_rastreador: idRastreador
        });
    }

    static sendApn(json){
        return Vue.http.post('vitana/apn', json);
    }

    static sendIp(json){
        return Vue.http.post('vitana/server1', json);
    }

    static output(json){
        return Vue.http.post('vitana/output', json);
    }

}
